import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const paymentPlanManage: IMcAppType = {
  name: "paymentPlanManage_SAP",
  path: "/my-account/payment-plans",
  description: "Payment Plans",
  navFlow: NavFlow.STANDARD,
  title: "Payment plan",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentPlanManage",
    customerType: CustomerType.sap,
  },
};
